module.exports = __webpack_public_path__ + "media/images/plan-grid4@2x-8d089fd8403877b875f05db695811b20.jpg";